// @owners { team: patients }
import { SPACING } from '@alto/design-library-tokens';
import { ActionSheetV2, Body, ExternalLink, LgPadding } from '@alto/design-system';
import React from 'react';
import { getCompanyName } from '~shared/config/getCompanyName';
import { getPrivacyPolicyUrl } from '~shared/constants';

export const AltoAssistantActionSheet = () => {
  const companyName = getCompanyName();

  return (
    <ActionSheetV2
      title={`${companyName} Assistant`}
      analyticsName="alto assistant info"
    >
      <LgPadding topPadding={SPACING.STATIC.NONE}>
        <Body>
          The {companyName} virtual assistant is an automated chatbot that helps you with basic prescription management
          tasks and helps connect you with the right {companyName} team member when needed. As a reminder, just like
          other messages you send to {companyName}, information you submit is subject to {companyName}’s{' '}
          <ExternalLink href={getPrivacyPolicyUrl()}>Privacy Policy</ExternalLink>.
        </Body>
      </LgPadding>
    </ActionSheetV2>
  );
};
